import React, {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import { PaymentForm, CreditCard } from 'react-square-web-payments-sdk';
import BaseModal from "../../theme/modals/BaseModal";
import api from "../../../store/api";
import settings from "../../../settings";
import {addErrorAlert, toggleGlobalLoader} from "../../../store/calls/alertLoadingDispatch";

// NEED TO AUTHENTICATE HERE, AND CONFIRM EMAIL

function PaymentModal({amount=9500, onSign, onCancel, txt, onClose = () => {}, onComplete}) {

    const userData = useSelector(state => state.user?.decodedTokenData || {})
    const applicationData = useSelector(state => state.applicationData?.app);


    const [failure, setFailure] = useState(null);


    return (
        <BaseModal visible onClose={onClose}>
                <div className="mb-4">
                    {txt}
                </div>


                {failure && <div className="has-text-centered my-4 has-text-danger">The payment failed to process.
                    Please ensure your card details are correct.</div>}

                <PaymentForm
                    applicationId={settings.squareProdAppId}
                    cardTokenizeResponseReceived={(token, verifiedBuyer) => {
                        toggleGlobalLoader(true);
                        api.post("/app/pay/", {
                            sourceId: token.token,
                            application_id: applicationData.id,
                            user_id: userData.user_id,
                            amount
                        }).then((res) => {
                            onComplete(res.data)
                        }).catch((err) => {
                            console.error(err)
                            setFailure(true);
                            setTimeout(() => setFailure(false), 10000)
                        })
                        .finally(() => toggleGlobalLoader(false))
                    }}
                    locationId='app_checkout'
                >
                    <CreditCard
                        buttonProps={{
                            css: {
                                borderRadius: 0,
                                backgroundColor: 'var(--primary-color)'
                            }
                        }}
                    />
                </PaymentForm>

            </BaseModal>
    )
}

export default PaymentModal;